import formatDateIso from '@/services/general/formatIsoDate';
import { BON_STOCK_TYPE_ENTREE, BON_STOCK_TYPE_SORTIE, ORIGINE_TYPE_DIVERS } from '@/configuration/bonStock/menuStockConf';

export default function genererBonStocks(ligne, client, societe) {
  const sensEntree = ligne.soldeBache > 0;
  const bonStock = {
    type: sensEntree ? BON_STOCK_TYPE_ENTREE : BON_STOCK_TYPE_SORTIE,
    dateBon: formatDateIso(new Date()),
    lieuDeStockageId: client?.id,
    origine: ORIGINE_TYPE_DIVERS,
    mouvements: [{
      quantite: Math.abs(ligne.soldeBache),
      produitId: sensEntree ? societe.produitVenteBonStockId : societe.produitAchatBonStockId,
    }],
    actif: true,
  };
  return bonStock;
}
